import { render, staticRenderFns } from "./new_extension_hours.vue?vue&type=template&id=2ecdf7d1"
import script from "./new_extension_hours.vue?vue&type=script&lang=js"
export * from "./new_extension_hours.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports